import { createUnleash } from 'shared/unleash/hook';
import type { UnleashToggles } from '@/interfaces';

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>();

export { UnleashProvider, useUnleash };
